import Hero from "../Component/Hero";
import AlurPeminjaman from "../Component/AlurPeminjaman";
import AllProductProduktif from "../Component/AllProductProduktif";

function PinjamanUsaha() {
    return (
        <>
            <div>
                <Hero
                    imageClass='usaha'
                    title='Pinjaman Usaha'
                    subTitle='P I N J A M A N &emsp;P R O D U K T I F'
                    explanation='
                        Fasilitas ini ditujukan bagi perusahaan / UKM atau pelaku usaha untuk mendapatkan modal kerja agar dapat mengembangkan usahanya.
                        <br/><br/>
                        Fasilitas pembiayaan modal usaha dari Danai.id mempunyai proses yang cepat dan tidak memerlukan aset tetap (<em>fixed asset</em>) seperti tanah & bangunan sebagai jaminan tetapi cukup dengan menggunakan invoice / tagihan (<em>Invoce Financing</em>) atau persediaan barang sebagai jaminan (<em>Inventory Financing</em>).'
                />
                <AllProductProduktif/>
                <AlurPeminjaman type='produktif'/>
            </div>
        </>
    );
}

export default PinjamanUsaha;
